var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-editor-overlay" }, [
    _c(
      "div",
      { staticClass: "image-editor-container" },
      [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.$t("auto.imageEditor")))]),
            _vm._v(" "),
            _c("div", { staticClass: "toolbar" }, [
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      { attrs: { title: "Çiz (" + _vm.shortcuts.draw + ")" } },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            attrs: {
                              type: _vm.mode === "draw" ? "primary" : "default",
                            },
                            on: { click: _vm.toggleDrawMode },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("brush"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.draw)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.mode === "draw"
                  ? _c(
                      "div",
                      { staticClass: "draw-options" },
                      [
                        _c(
                          "a-popover",
                          {
                            attrs: { placement: "bottom", trigger: "click" },
                            model: {
                              value: _vm.colorPickerVisible,
                              callback: function ($$v) {
                                _vm.colorPickerVisible = $$v
                              },
                              expression: "colorPickerVisible",
                            },
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _c(
                                "div",
                                { staticClass: "color-picker" },
                                _vm._l(_vm.colors, function (color) {
                                  return _c("div", {
                                    key: color,
                                    staticClass: "color-option",
                                    style: {
                                      backgroundColor: color,
                                      border:
                                        _vm.drawColor === color
                                          ? "2px solid #1890ff"
                                          : "1px solid #e8e8e8",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectColor(color)
                                      },
                                    },
                                  })
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-button", {
                              staticClass: "color-btn",
                              style: { backgroundColor: _vm.drawColor },
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("a-slider", {
                          staticClass: "width-slider",
                          attrs: { min: 1, max: 20, step: 1 },
                          model: {
                            value: _vm.drawWidth,
                            callback: function ($$v) {
                              _vm.drawWidth = $$v
                            },
                            expression: "drawWidth",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: { title: "Metin (" + _vm.shortcuts.text + ")" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            attrs: {
                              type: _vm.mode === "text" ? "primary" : "default",
                            },
                            on: { click: _vm.toggleTextMode },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("title"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.text)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.mode === "text"
                  ? _c(
                      "div",
                      { staticClass: "text-options draw-options" },
                      [
                        _c(
                          "a-popover",
                          {
                            attrs: { placement: "bottom", trigger: "click" },
                            model: {
                              value: _vm.textColorPickerVisible,
                              callback: function ($$v) {
                                _vm.textColorPickerVisible = $$v
                              },
                              expression: "textColorPickerVisible",
                            },
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _c(
                                "div",
                                { staticClass: "color-picker" },
                                _vm._l(_vm.colors, function (color) {
                                  return _c("div", {
                                    key: color,
                                    staticClass: "color-option",
                                    style: {
                                      backgroundColor: color,
                                      border:
                                        _vm.textColor === color
                                          ? "2px solid #1890ff"
                                          : "1px solid #e8e8e8",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectTextColor(color)
                                      },
                                    },
                                  })
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-button", {
                              staticClass: "color-btn",
                              style: { backgroundColor: _vm.textColor },
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("a-slider", {
                          staticClass: "width-slider",
                          attrs: { min: 10, max: 60, step: 1 },
                          model: {
                            value: _vm.fontSize,
                            callback: function ($$v) {
                              _vm.fontSize = $$v
                            },
                            expression: "fontSize",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title:
                            "Sola Döndür (" + _vm.shortcuts.rotateLeft + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.rotateLeft },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("rotate_left"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.rotateLeft)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title:
                            "Sağa Döndür (" + _vm.shortcuts.rotateRight + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.rotateRight },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("rotate_right"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.rotateRight)),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: "Yakınlaştır (" + _vm.shortcuts.zoomIn + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.zoomIn },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("zoom_in"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.zoomIn)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: "Uzaklaştır (" + _vm.shortcuts.zoomOut + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.zoomOut },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("zoom_out"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.zoomOut)),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: "Sıfırla (" + _vm.shortcuts.reset + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            on: { click: _vm.resetImage },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("refresh"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.reset)),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tool-group" }, [
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: "Geri Al (" + _vm.shortcuts.undo + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            attrs: { disabled: !_vm.canUndo },
                            on: { click: _vm.undo },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("undo"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.undo)),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tool-wrapper" },
                  [
                    _c(
                      "a-tooltip",
                      {
                        attrs: {
                          title: "İleri Al (" + _vm.shortcuts.redo + ")",
                        },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "tool-btn",
                            attrs: { disabled: !_vm.canRedo },
                            on: { click: _vm.redo },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("redo"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "shortcut-hint" }, [
                      _vm._v(_vm._s(_vm.shortcuts.redo)),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "editor-container" }, [
            _c("canvas", {
              ref: "editorCanvas",
              staticClass: "canvas-style",
              attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
              on: {
                mousedown: _vm.onMouseDown,
                mousemove: _vm.onMouseMove,
                mouseup: _vm.onMouseUp,
                mouseleave: _vm.onMouseLeave,
                dblclick: _vm.onDblClick,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thumbnail-container" }, [
            _vm.images[_vm.currentEditIndex]
              ? _c(
                  "div",
                  { staticClass: "caption-section" },
                  [
                    _c("a-input", {
                      staticClass: "caption-input",
                      attrs: {
                        placeholder: "Seçili resme açıklama ekleyin...",
                      },
                      model: {
                        value: _vm.images[_vm.currentEditIndex].caption,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.images[_vm.currentEditIndex],
                            "caption",
                            $$v
                          )
                        },
                        expression: "images[currentEditIndex].caption",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "thumbnail-list" },
              [
                _vm._l(_vm.images, function (image, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "thumbnail-item",
                      class: { active: index === _vm.currentEditIndex },
                      on: {
                        click: function ($event) {
                          return _vm.changeImage(index)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: { src: image.preview, alt: image.file.name },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "thumbnail-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "delete-btn",
                              attrs: {
                                type: "danger",
                                shape: "circle",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeImage(index)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "thumbnail-item add-new",
                    on: { click: _vm.triggerAddImage },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("add_photo_alternate"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Yeni Resim Ekle")]),
                    _vm._v(" "),
                    _c("input", {
                      ref: "addImageRef",
                      staticStyle: { display: "none" },
                      attrs: { type: "file", multiple: "", accept: "image/*" },
                      on: { change: _vm.onNewImagesSelected },
                    }),
                  ]
                ),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "a-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v("İptal")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.handleSave } },
              [_vm._v("Kaydet")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.editingText
          ? _c("TextEditModal", {
              attrs: {
                visible: _vm.editingText !== null,
                text: _vm.editingText,
                colors: _vm.colors,
              },
              on: {
                save: function (updatedText) {
                  _vm.editingText.text = updatedText.text
                  _vm.editingText.color = updatedText.color
                  _vm.editingText.size = updatedText.size
                  _vm.editingText = null
                  _vm.redrawAll()
                  _vm.saveState()
                },
                cancel: function () {
                  _vm.editingText = null
                  _vm.redrawAll()
                },
                redraw: _vm.redrawAll,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }